export default __webpack_public_path__ + "assets/5c1b570580677386286a3128b46c3f6c.jpg";